import {
  SHOW_NOTIFICATION,
  SHOW_EXPIRED_NOTIFICATION,
} from './types/NotificationActionTypes';

export const showNotification = ({ message, type, duration = 5 }) => ({
  type: SHOW_NOTIFICATION,
  payload: {
    notification: { message, type, duration },
  },
});

export const showExpiredNotification = ({
  message, type, duration = 10, history,
}) => ({
  type: SHOW_EXPIRED_NOTIFICATION,
  payload: {
    notification: { message, type, duration },
  },
  history,
});

export const clearNotification = () => ({
  type: SHOW_NOTIFICATION,
  payload: {
    notification: null,
  },
});
